import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { setViewpoint } from "features/render";

import { ProcoreToolMode, State } from "./types";

const initialState: State = {
    activeToolMode: ProcoreToolMode.Default,
};

export const procoreUxSlice = createSlice({
    name: "procoreUx",
    initialState,
    reducers: {
        setActiveToolMode: (state, action: PayloadAction<ProcoreToolMode>) => {
            state.activeToolMode = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(setViewpoint, (state) => {
            state.activeToolMode = ProcoreToolMode.Default;
        });
    },
});

const { actions, reducer } = procoreUxSlice;
export { actions as procoreUxActions, reducer as procoreUxReducer };
